import { all } from 'redux-saga/effects';
import { combinedSaga as commonDashboardSaga } from './CommonDashboard';
import { combinedSaga as userProfileSaga } from './UserProfile';
import { combinedSaga as myOrderSaga } from './MyOrder';
import { combinedSaga as pendingOrderSaga } from './PendingOrder';
import { combinedSaga as customerMyOrderSaga } from './CustomerMyOrder'
import { combinedSaga as managedEquipmentSaga } from './ManagedEquipment'
import { combinedSaga as purchaseOrderSaga } from './PurchaseOrder'
import { combinedSaga as assetTransferSaga } from './AssetTransfer'
import { combinedSaga as AppRole } from './AppRole';
import { combinedSaga as userManagementSaga } from './UserManagement'
import RequisitionDropDownService from '../Service/AssetManagement/RequisitionDropDownService'
import AssetTypeService from "../Service/AssetManagement/AssetTypeService"
import AssetSubTypeService from "../Service/AssetManagement/AssetSubTypeService"
import UpfitOptionService from "../Service/AssetManagement/UpfitOptionService"
import DriveTrainService from "../Service/AssetManagement/DriveTrainService"
import CostCenterService from "../Service/AssetManagement/CostCenterService"
import VehicleCapacityService from "../Service/AssetManagement/vehicleCapacityService"
import NoOfDoorsService from "../Service/AssetManagement/NoOfDoorsService"
import AssetNumber from "../Service/AssetManagement/AssetNumberService"
import ReasonTypeService from "../Service/AssetManagement/ReasonTypeService"
import OrderService from "../Service/OrderManagement/OrderService"
import ConditionService from "../Service/AssetManagement/ConditionService"
import StatusService from "../Service/AssetManagement/StatusService"
import UploadAttachmentsService from "../Service/AssetManagement/UploadAttachmentsService"
import EquipmentService from "../Service/AssetManagement/EquipmentService"
import ApprovalService from '../Service/OrderManagement/ApprovalService'
import VendorDetailsService from "../Service/Organization/VendorDetailsService"
import DriverTitleService from "../Service/AssetManagement/DriverTitleService"
import managedEquipmentDropDownService from '../Service/AssetManagement/ManagedEquipmentDropDownService'
import CatalogItemService from '../Service/AssetManagement/CatalogItemService'
import AlertNotificationServices from '../Service/AlertNotification/AlertNotificationServices';
import DivisionsService from '../Service/Organization/DivisionsService';
import CostCentersService from '../Service/Organization/CostCentersService';
import AssignmentTransferTypesService from '../Service/OrderManagement/AssignmentTransferTypesService'
import TransferApprovalServices from '../Service/Transfer/TransferApprovalService'
import TransferOrderServices from '../Service/Transfer/TransferService';
import PriceInfoService from "../Service/AssetManagement/PriceInfoService";
import TransferGridServices from '../Service/TransferService/TransferGridService';
import DispositionChoiceService from '../Service/OrderManagement/DispositionChoiceService';
import reasonCodeService from '../Service/OrderManagement/reasonCodeService';
import StatesService from '../Service/Organization/StatesService';
import RegionsService from '../Service/Organization//RegionService';
import CitiesService from '../Service/Organization/CitiesService';
import FleetProcessingService from '../Service/OrderManagement/FleetProcessingService';
import OrderGridDropdownsServices from '../Service/OrderManagement/OrderGridDropdownsServices'
import BulkOrderDashboardServices from '../Service/OrderManagement/BulkOrderDashboardServices'
import BulkOrderServices from '../Service/BulkOrder/BulkOrderServices'
import PurchaseBulkOrderServices from '../Service/BulkOrder/PurchaseBulkOrderServices'
import CatalogManagementServices from '../Service/CatalogManagement/CatalogManagementServices'
import titleServices from '../Service/Organization/TitleService';
import DivisionalApproverRequisitionTypeService from '../Service/OrderManagement/DivisionalApproverRequisitionTypeService';
import primaryApproverService from '../Service/Identity/PrimaryApproverService';
import regionByEmailService from '../Service/Identity/RegionService';
import EmployeeInfoServices from '../Service/OrderManagement/EmployeeInfoServices/EmployeeInfoServices'
import QuestionOptionsService from '../Service/AssetInventory/QuestionOptionsService'
import SaveAssessmentService from '../Service/AssetInventory/SaveAssessmentService'
import GetAllAssessmentsService from '../Service/AssetInventory/GetAllAssessmentsService'
import UsersService from '../Service/AssetInventory/UsersService'
import UserProfileService from '../Service/Identity/UserProfileService'
import AdminTaskServices from '../Service/FleetManagement/AdminTaskService'
import GLAccountCodesService from '../Service/FleetManagement/GLAccountCodesService'
import FleetCreatePOService from "../Service/FleetManagement/FleetCreatePOService"
import getAuditDatesListService from '../Service/AssetInventory/AuditDates'
import getFleetItemCancelService from '../Service/FleetManagement/FleetItemCancelService'
import saveReceivingBranchServices from '../Service/FleetManagement/FleetTransferReceivingBranchService'
import FleetAssetCommentsServices from '../Service/FleetManagement/FleetAssetCommentsSaveService'
import FleetDispositionSaveServices from '../Service/FleetManagement/FleetDispositionSaveServices'
import FleetDispositionLocationSaveServices from '../Service/FleetManagement/FleetDispositionLocationSaveServices'
import itemStatusListService from '../Service/FleetManagement/itemStatusListService'
import FleetAssetChangeLogService from '../Service/FleetManagement/FleetAssetChangeLogServices'
import UserServices from '../Service/Identity/UserService'
import ErrorLogServices from '../Service/Identity/ErrorLogService'
import FleetDispositionPaymentSaveService from '../Service/FleetManagement/FleetDispositionPaymentSaveServices'
import AutoCompleteAddressSearchServices from '../Service/Organization/AutoCompleteAddressSearchService'
import AutoCompleteAddressDetailsServices from '../Service/Organization/AutoCompleteAddressDetailsService'
import FuelTypeService from "../Service/AssetManagement/FuelTypeService"
import BulkOrderSaveServices from  '../Service/BulkOrder/BulkOrderSaveServices'
import BulkOrderByIdServices from '../Service/BulkOrder/BulkOrderByIdService'
import MergerAndAquisitionService from '../Service/AssetInventory/mergerAndAquisitionService'
import DispositionPenaltyFeeServices from '../Service/OrderManagement/DispositionPenaltyFeeServices'
import ReportListServices from '../Service/Report/ReportListServices'
import AcquisitionCodeMaintenanceServices from '../Service/Report/AcquisitionCodeMaintenanceServices'
import CreateNewCodeServices from '../Service/OrderManagement/AcquisitionCodeServices'
import DispositionPenaltyFlagServices from '../Service/OrderManagement/DispositionPenalityFlagServices'
import ApprovalHistoryServices from '../Service/ApprovalHistory/ApprovalHistoryServices'
import AssetItemStatusHeaderDetailServices from '../Service/FleetManagement/FleetAssetItemStatusServices'
import FleetManagementService from '../Service/FleetManagement/FleetManagementService'
import AssetFleetProcessingService from '../Service/FleetManagement/AssetFleetProcessingService'
import AssetFleetLinkattachmentService from '../Service/FleetManagement/AssetFleetProcessingLinkAttachmentService'
import CatalogDropDownUpdateServices from '../Service/AssetManagement/CatalogItemDropDownUpdateService'
import ResetAssetInventoryServices from '../Service/AssetInventory/AssetInventoryResetService'
import UserFilterBySearchTextServices from '../Service/Identity/UserBySearchTextService'
import MarketByRegionServices from '../Service/Organization/MarketByRegionService'
import AuditReadinessWorkBookServices from '../Service/AssetManagement/AuditReadinessworkBookService'
import CostCenterByMarketServices from '../Service/Organization/CostCenterByMarketService'
import PoVendorEmailServices from '../Service/AlertNotification/PoVendorEmailServices';
import FleetRefreshPurchaseOrderServices from '../Service/FleetManagement/FleetRefreshPurchaseOrderServices';
import PoVendorEmailHistoryService from '../Service/FleetManagement/FleetPOVendorEmailHistoryService';
import FleetPurchaseOrderHistoryServices from '../Service/FleetManagement/FleetPurchaseOrderHistoryService';
import AssetAuditHistoryLogServices from '../Service/AssetInventory/AssetAuditResetHistoryLogService';
import BranchAdminAccessServices from '../Service/AssetInventory/BranchAdminAccessService';
import FleetItemReturnService from '../Service/FleetManagement/FleetItemReturnService';
import JobtitleServices from '../Service/AssetManagement/JobTitleService';
import SuperRegionServices from '../Service/Organization/SuperRegionServices'
import ApprovalHierarchyServices from '../Service/OrderManagement/ApprovalHierarchyServices'
import ApprovalListAssignmentServices from '../Service/OrderManagement/ApprovalListAssignmentService'
import RegionDropDownService from "../Service/Organization/RegionDropdownService"
import MarketDropDownService from "../Service/Organization/MarketDropDownServices"
import ApprovalHistoryReportService from "../Service/OrderManagement/ApprovalHistoryReportService"
import ComplianceReport from "../Service/OrderManagement/ComplianceReportServices"
import BranchDropDownService from "../Service/Organization/BranchDropDownService"
import OutofOfficeService from '../Service/OrderManagement/OutOfOfficeService'
import UserDefaultLocationServices from '../Service/Identity/DefaultLocationService';
import ActiveAssetDashboardServices from '../Service/AssetManagement/ActiveAssetDashboardService';
import ActiveAssetDropDownServices from '../Service/AssetManagement/ActiveAssetDropDownService';
import AssetEoneDetailsService from '../Service/AssetManagement/AssetEoneDetailsService';
import ActiveAssetReportServices from '../Service/AssetManagement/ActiveAssetReportService';
import BillOfSaleService from '../Service/OrderManagement/BillOfSaleService';
import BarcodeReportService from '../Service/Report/BarcodeReportService';

export default function* rootSaga() {
  yield all([
    RequisitionDropDownService(),
    commonDashboardSaga(),
    userProfileSaga(),
    myOrderSaga(),
    pendingOrderSaga(),
    customerMyOrderSaga(),
    managedEquipmentSaga(),
    purchaseOrderSaga(),
    assetTransferSaga(),
    AppRole(),
    userManagementSaga(),
    AssetTypeService(),
    AssetSubTypeService(),
    UpfitOptionService(),
    DriveTrainService(),
    CostCenterService(),
    VehicleCapacityService(),
    NoOfDoorsService(),
    AssetNumber(),
    ReasonTypeService(),
    OrderService(),
    ConditionService(),
    StatusService(),
    UploadAttachmentsService(),
    EquipmentService(),
    ApprovalService(),
    VendorDetailsService(),
    DriverTitleService(),
    managedEquipmentDropDownService(),
    CatalogItemService(),
    AlertNotificationServices(),
    DivisionsService(),
    CostCentersService(),
    AssignmentTransferTypesService(),
    AlertNotificationServices(),
    TransferApprovalServices(),
    TransferOrderServices(),
    PriceInfoService(),
    ///Transfer grid service
    TransferGridServices(),
    DispositionChoiceService(),
    reasonCodeService(),
    StatesService(),
    RegionsService(),
    CitiesService(),
    FleetProcessingService(),
    BulkOrderDashboardServices(),
    BulkOrderServices(),
    PurchaseBulkOrderServices(),
    CatalogManagementServices(),
    OrderGridDropdownsServices(),
    EmployeeInfoServices(),
    QuestionOptionsService(),
    SaveAssessmentService(),
    titleServices(),
    DivisionalApproverRequisitionTypeService(),
    primaryApproverService(),
    regionByEmailService(),
    EmployeeInfoServices(),
    GetAllAssessmentsService(),
    UsersService(),
    UserProfileService(),
    AdminTaskServices(),
    GLAccountCodesService(),
    FleetCreatePOService(),
    getAuditDatesListService(),
    getFleetItemCancelService(),
    saveReceivingBranchServices(),
    FleetAssetCommentsServices(),
    FleetDispositionSaveServices(),
    FleetDispositionLocationSaveServices(),
    itemStatusListService(),
    FleetAssetChangeLogService(),
    UserServices(),
    ErrorLogServices(),
    FleetDispositionPaymentSaveService(),
    AutoCompleteAddressSearchServices(),
    AutoCompleteAddressDetailsServices(),
    FuelTypeService(),
    BulkOrderSaveServices(),
    BulkOrderByIdServices(),
    MergerAndAquisitionService(),
    DispositionPenaltyFeeServices(),
    ReportListServices(),
    AcquisitionCodeMaintenanceServices(),
    DispositionPenaltyFlagServices(),
    CreateNewCodeServices(),
    ApprovalHistoryServices(),
    AssetItemStatusHeaderDetailServices(),
    FleetManagementService(),
    AssetFleetProcessingService(),
    AssetFleetLinkattachmentService(),
    CatalogDropDownUpdateServices(),
    ResetAssetInventoryServices(),
    UserFilterBySearchTextServices(),
    MarketByRegionServices(),
    AuditReadinessWorkBookServices(),
    CostCenterByMarketServices(),
    PoVendorEmailServices(),
    FleetRefreshPurchaseOrderServices(),
    PoVendorEmailHistoryService(),
    FleetPurchaseOrderHistoryServices(),
    AssetAuditHistoryLogServices(),
    BranchAdminAccessServices(),
    FleetItemReturnService(),
    JobtitleServices(),
    SuperRegionServices(),
    ApprovalHierarchyServices(),
    ApprovalListAssignmentServices(),
    RegionDropDownService(),
    MarketDropDownService(),
    ComplianceReport(),
    ApprovalHistoryReportService(),
    BranchDropDownService(),
    OutofOfficeService(),
    UserDefaultLocationServices(),
    ActiveAssetDashboardServices(),
    ActiveAssetDropDownServices(),
    AssetEoneDetailsService(),
    ActiveAssetReportServices(),
    BillOfSaleService(),
    BarcodeReportService()
  ])
}
